import { TrackService } from './../../../service/track.service';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { UserdataService } from '../../../service/userdata.service';
import { MatDialog } from '@angular/material/dialog';
import { SettingsComponent } from '../settings/settings.component';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { RenameStreamComponent } from './rename-stream/rename-stream.component';
import { AppdataService } from '../../../service/appdata.service';
import { AiService } from '../../../service/ai.service';
import { Userdata } from '../../../interfaces/userdata';

@Component({
    selector: 'app-stream-dashboard',
    standalone: false,
    templateUrl: './stream-dashboard.component.html',
    styleUrl: './stream-dashboard.component.scss'
})
export class StreamDashboardComponent implements OnDestroy, OnInit {

    // Injections
    appData = inject(AppdataService);
    aiService = inject(AiService);
    trackService = inject(TrackService);
    user = inject(UserdataService);
    dialog = inject(MatDialog);
    route = inject(ActivatedRoute);

    // Variables
    userData: Userdata | undefined;
    routeQueryParams$: Subscription = new Subscription();
    today = new Date().toLocaleDateString()
    yesterday = new Date(new Date().setDate(new Date().getDate() - 1)).toLocaleDateString();
    started: boolean = false;

    // Objects
    userStreams: any[] = [];
    dataTracks: any;
    trackDataToShow: any[] = [];




    async ngOnInit(): Promise<void> {
        this.user.data.subscribe(data => {
            if (data) {
                this.userData = data;
            }
        });
        this.routeQueryParams$ = this.route.queryParams.subscribe((params) => {
            if (params['settings']) {
                this.openSettings(params['page']);
            }
            if (params['new-stream']) {
                this.newStream();
            }
        });
        this.appData.tracks.subscribe((data) => {
            if (data) {
                this.dataTracks = data
            }
        });

        this.trackService.userTracks.subscribe((tracks) => {
            if (tracks && tracks.length !== 0) {
                this.userStreams = tracks;
                this.groupDataForView();
            }
        });

        //  Initial Load of UserTracks
        await this.trackService.loadUserTrackData();
        this.aiService.resetChat();

    }

    async groupDataForView() {
        if (this.started === true) return
        this.started = true;
        this.trackDataToShow = [];
        let counter = 0;

        while ((!this.dataTracks || this.userStreams.length == 0) && counter < 100) {
            await new Promise(resolve => setTimeout(resolve, 100));
            counter++;
        }
        for await (let track of this.userStreams) {
            track.trackData = await this.dataTracks?.find((t: any) => t.id == track.trackId);
            let date = track.dateUpdated || track.dateCreated;
            let day = new Date(date).toLocaleDateString()

            let exists = await this.trackDataToShow.find((s: any) => s.date == day);
            if (!exists) {
                this.trackDataToShow.push({
                    date: day,
                    tracks: [track]
                })
            } else {
                this.trackDataToShow.forEach((t) => {
                    if (t.date == day) {
                        t.tracks.push(track);
                    }
                })
            }
        }
        this.started = false;
    }


    ngOnDestroy(): void {
        this.routeQueryParams$.unsubscribe();
    }
    async openSettings(page: number) {
        let dia = this.dialog.open(SettingsComponent, {
            data: { "page": page },
            autoFocus: false,
        });
        // dia.afterClosed().subscribe((result) => {
        //   // this.router.navigate([], {
        //   //   relativeTo: this.route,
        //   //   queryParams: { 'settings': null, 'page': null },
        //   //   queryParamsHandling: 'merge'
        //   // });
        // });
    }
    async newStream() {
        // let dia = this.dialog.open(NewstreamComponent, {
        //   data: this.userData,
        //   width: '1346px',
        //   panelClass: 'flex-dialog'
        // });
        // dia.afterClosed().subscribe((result) => {
        //   let url = [];
        //   if (result) {
        //     url = result;
        //   }
        //   if (isArray(url) && url.length == 0) {
        //     this.router.navigate(url, {
        //       relativeTo: this.route,
        //       queryParams: { 'new-stream': null },
        //       queryParamsHandling: 'merge'
        //     });
        //   }

        // });

        this.dialog.open(RenameStreamComponent, {
            panelClass: 'small-dialog',
            hasBackdrop: true
        });

    }
}
